export default "__VITE_ASSET__ChDnRs2n__"